module.exports = __webpack_public_path__ + "img/reference56.dbf93dde.jpg";